import { schema } from 'normalizr';

export const CLUB_LIST = '/:clientToken/clubs';

// ------------------------------------
// Schemas
// ------------------------------------

const CLUB_SCHEMA = new schema.Entity('clubs', {}, { idAttribute: '@id' });

export default {
  Club: CLUB_SCHEMA,
};
